<template>
    <div
        class="StatCardRow"
        :style="{'grid-template-columns':`repeat(${maxRowCount}, 1fr`}"
    >
        <template
            v-if="isLoading"
        >
            <RPBaseStatCard
                v-for="i in placeholderCount"
                :key="i"
                :status="status"
            />
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>
<script>
import stat from 'status';
import RPBaseStatCard from'./RPBaseStatCard.vue';

export default {
    name: 'RPStatCardRow',
    components: {
        RPBaseStatCard
    },
    props: {
        placeholderCount: {
            type: Number,
            default: 4
        },
        maxRowCount: {
            type: Number,
            default: 4
        },
        status: {
            type: String,
            default: stat.STANDBY,
        }
    },
    computed: {
        isLoading(){
            return this.status === stat.LOADING;
        },

    }
};
</script>
<style lang="scss">
    .StatCardRow {
        width: 100%;
        @media(min-width: $max-md-width){
            display: grid;
            gap: 1rem;
        }
        @media(max-width: $max-md-width){
            display: flex;
            flex-direction: column;
        }

    }
</style>
